
export const renderHtml = (text: string): React.ReactNode => {
  return <span dangerouslySetInnerHTML={{ __html: text }} />
}
